import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
import Cache from '../cache/cache';

// 配置文件查询
export default async function artcleGet(context: Context, parms: CustomQuery): Promise<ApiResult> {
  // 获取缓存
  const cacheKey = 'artcleGet_' + JSON.stringify(parms);
  const cache = Cache.getCache(context, cacheKey);
  if (cache) {
    return cache;
  }

  const url = new URL('/mall/article/list', context.config.api.url);
  const { data: res } = await context.client.post(url.href, parms);

  // 设置缓存
  Cache.setCache(context, cacheKey, res);
  return res;
}
